









import { Vue, Component } from 'vue-property-decorator';
import { Emit, Prop } from '@samclick-commons';

@Component
export default class SamclickNumberInput extends Vue {
    @Prop({ default: '' }) private value!: number;

    @Emit('input')
    input(e:any) {
      return e;
    }

    @Emit('change')
    change(e:any) {
      return e;
    }

    get defaultAttrs() {
      return {
        size: 'small',
        'controls-position': 'right',
        class: 'full-width text-left',
        min: 0,
      };
    }

    get overrideAttrs() {
      return Object.assign(this.defaultAttrs, this.$attrs);
    }
}
